import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

type Props = {
  /** 'center' inyecta en el slot centrado del toolbar; 'actions' en el de la derecha (junto al título). */
  slot: 'center' | 'actions';
  children: React.ReactNode;
};

const SLOT_IDS: Record<Props['slot'], string> = {
  center: 'kt_toolbar_center_slot',
  actions: 'kt_toolbar_actions_slot',
};

/**
 * Permite que una página inyecte contenido (fecha, botones) dentro del
 * toolbar global de título, en vez de repetir esa fila dentro de cada
 * pantalla — ahorra espacio vertical para el contenido de la página.
 */
const ToolbarPortal: React.FC<Props> = ({ slot, children }) => {
  const [target, setTarget] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setTarget(document.getElementById(SLOT_IDS[slot]));
  }, [slot]);

  if (!target) return null;
  return ReactDOM.createPortal(children, target);
};

export { ToolbarPortal };
